import { Input } from "@evergis/ui";
import React, { FC, ReactNode, useCallback } from "react";
import { useTranslation } from "react-i18next";
import {
  ExtendedParameters,
  ExtendedParametersProps,
} from "../../DialogComponents/ExtendedParameters/ExtendedParameters";
import { ResourceMeta } from "../../DialogComponents/ResourceMeta/ResourceMeta";
import { useAddProxyServiceContext } from "./AddProxyServiceProvider";
import { NameContainer, LayerProjectMetaBlock, SystemNameText } from "./styled";

interface ProxyServiceMetaProps extends ExtendedParametersProps {
  showSystemName?: boolean;
  extra?: ReactNode;
}

export const ProxyServiceMeta: FC<ProxyServiceMetaProps> = ({ showSystemName, onExpand, extra }) => {
  const { t } = useTranslation("dialogs");
  const { meta, updateMeta } = useAddProxyServiceContext();
  const { setAlias } = updateMeta;
  const { name } = meta;
  const updateAlias = useCallback((e: React.ChangeEvent<HTMLInputElement>) => setAlias(e.target.value), [setAlias]);

  return (
    <>
      <NameContainer>
        <Input type="text" label={t("newLayer.layerName")} value={meta.alias} onChange={updateAlias} width="100%" />
        <SystemNameText>{name}</SystemNameText>
      </NameContainer>
      <ExtendedParameters onExpand={onExpand}>
        <LayerProjectMetaBlock reverseRow>
          <ResourceMeta
            meta={meta}
            updateMeta={updateMeta}
            showCopyrightAndDescription
            showSystemName={showSystemName}
            extra={extra}
          />
        </LayerProjectMetaBlock>
      </ExtendedParameters>
    </>
  );
};
